














import { Result } from '@empathy/search-types';
import { Component, Vue } from 'vue-property-decorator';
import { mapGetters, mapState, Store } from 'vuex';
import { DiscoveryWallBlockConfig, EmpathyXConfig } from '../../models';
import { GETTERS_KEYS, RootStoreState, SUBMODULES_PATHS } from '../../store';
import DiscoveryWallBlock from './discovery-wall-block.vue';

@Component({
  components: { DiscoveryWallBlock },
  computed: {
    ...mapState(SUBMODULES_PATHS.core, ['open']),
    ...mapGetters({
      config: GETTERS_KEYS.config.config
    })
  }
})
export default class DiscoveryWall extends Vue {
  config: EmpathyXConfig;
  open: boolean;
  $store: Store<RootStoreState>;

  get discoverWallBlocks(): [string, DiscoveryWallBlockConfig][] {
    return Object.entries(this.config.discoveryWall.blocks)
      .filter(([, blockConfig]) => (this.$store.getters[blockConfig.resultsGetter] as Result[]).length > 0)
      .sort(([, a], [, b]) => a.order - b.order);
  }

  get someBlockHasResults(): boolean {
    return this.discoverWallBlocks.length > 0;
  }

  get renderDiscoveryWallBlocks(): boolean {
    return this.$store.state.emptySearch.discoveryWall.loading || this.someBlockHasResults;
  }
}
